
import { useContext, useState, useEffect } from "react";

import { useNavigate } from "react-router-dom"; 
import { useTranslation } from "react-i18next";
import "./CollectorLoginPage.css";
import { Link } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import { loginCollector } from "../../api/collectorApi"; 
import { saveToken, saveUser } from "../../utils/auth";

import img1 from "../../assest/user3.png";
import img2 from "../../assest/user3.png";
import img3 from "../../assest/user3.png";

// import img5 from "../../assest/ips.png";
import defaultPhoto from "../../assest/user-default.png";
import ProfileColPagesssContext from "../../context/ProfileColPagesssContext";

function CollectorLoginPage() {
  const navigate = useNavigate(); 
 const { t, i18n } = useTranslation();   
    const { setProfilecolpagesssData } = useContext(ProfileColPagesssContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
useEffect(() => {
    const mountWidget = () => {
      if (window.RAG_WIDGET?.init && !document.getElementById("rag-widget-root")) {
        window.RAG_WIDGET.init({ containerId: "rag-widget-mount" });
      }
    };

    mountWidget();
    const retry = setTimeout(mountWidget, 300);

    return () => {
      clearTimeout(retry);
      document.getElementById("rag-widget-root")?.remove();
      document.getElementById("rag-widget-styles")?.remove();
    };
  }, []);
 
  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const validatePassword = (password) =>
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(password);


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) return setError("Please fill in all fields.");
    if (!validateEmail(email)) return setError("Enter a valid email address.");
    if (!validatePassword(password)) {
      return setError(
        "Password must contain uppercase, lowercase, number & special character."
      );
    }

    setError("");

    try {
      const response = await loginCollector({ email, password });
      // console.log("Login API response:", response);

      const data = response.data;

      if (data?.success && data?.data?.token) {
        const token = data.data.token;
        const admin = data.data.admin; 


      
        saveToken(token);

      
        const normalizedUser = {
          adminId: admin.adminId || "",
          name: admin.name || "",
          email: admin.email || "",
          phone: admin.mobile || "",
          dept: admin.designation || "",
          office: admin.district || "",
         profilePicture: admin.profilePicture || defaultPhoto,

        };

        saveUser(normalizedUser);
        setProfilecolpagesssData(normalizedUser);

        // console.log("User saved & context updated:", normalizedUser);

       
        navigate("/dashboard");
        
      } else {
        setError(data?.message || "Invalid credentials");
      }

    } catch (err) {
  if (err.response) {
    const status = err.response.status;

    if (status === 401 || status === 400) {
      setError("Invalid credentials");
    } else {
      setError("Something went wrong. Please try again.");
    }
  } else {
    setError("Unable to connect to server. Please try later.");
  }
}

  };

  return (
    <div className="collector-login-page">
          <div id="rag-widget-mount"></div>
      <div className="collector-left">
        <div className="collector-header">
          <div className="minister-section">
            <div className="ministerrow">
                  <img src={img1} alt="Chief Minister" />
                  <h4>{t("chiefMinisterName")}</h4>
                  <p>{t("chiefMinister")}</p>
                </div>
            <div className="minister-row">
                    <div className="minister">
                        <img src={img2} alt="Deputy Minister" />
                        <h4>{t("deputyCMName1")}</h4>
                        <p>{t("deputyCM")}</p>
                      </div>
              
                         <div className="minister">
                     <img src={img3} alt="Deputy Minister" />
                     <h4>{t("deputyCMName2")}</h4>
                     <p>{t("deputyCM2")}</p>
                   </div>
            </div>
          </div>
        </div>

     
           <div className="collector-title">
          <h2>{t("title")}</h2>
        </div>
      </div>

      <div className="collector-right">
        <div className="login-card">
       <h2>{t("signIn")}</h2>

<form onSubmit={handleSubmit}>
  <label>{t("emailLabel")}</label>
  <input
    type="email"
    placeholder={t("emailPlaceholder")}
    value={email}
    onChange={(e) => setEmail(e.target.value)}
    required
  />

  <label>{t("passwordLabel")}</label>
  <div className="password-wrapper">
    <input
      type={showPassword ? "text" : "password"}
      placeholder={t("passwordPlaceholder")}
      value={password}
      onChange={(e) => setPassword(e.target.value)}
      required
    />
    <span
      className="password-toggle"
      onClick={() => setShowPassword(!showPassword)}
    >
      {showPassword ? <FaEyeSlash /> : <FaEye />}
    </span>
  </div>

  {error && <p className="error-message">{error}</p>}

  <button type="submit">{t("loginButton")}</button>
</form>

<div className="login-footer">
  <Link to="/collectorForgetPassword" state={{ email }}>
    {t("forgotPassword")}
  </Link>
</div>
        </div>
      </div>
    </div>
  );
}

export default CollectorLoginPage;
